<template>
  <FullScreenLoading v-if="fullScreenloading"/>

  <form-wizard key="1" :startIndex="0" v-else class="mt-3" ref="onboardingWizard2" color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="go back" subtitle="" nextButtonText="continue" finishButtonText="start my journey" stepSize="xs">

  <!--   <div slot="custom-buttons-right">
      <div class="m-1 mb-4 text-center" >
        <vx-tooltip text="go to the app">
          <a href="#" @click="skipTour" class="text-grey hover:underline cursor-pointer">end tour</a>
        </vx-tooltip>
      </div>
    </div> -->



    <span slot="custom-buttons-right" slot-scope="props">
      <span class="m-1 mb-2 text-center" v-if="props.activeTabIndex === 0">
        <!-- <vx-tooltip text="go to the login page"> -->
          <span class="hover:underline cursor-pointer mr-2" @click="skipTour">exit flow</span>
        <!-- </vx-tooltip> -->
      </span>
    </span>



    <div slot="title">
      <img src="/improvee_logo.svg" class="flex-1 fill-current text-primary" height="38" />
    </div>

    <!-- What I Want =========================================================  -->
<!--     <tab-content title="" :before-change="trackStep('what-you-want-to-accomplish')">

      <div class="md:flex">
        <div class="w-1/2 mx-auto flex content-center">
          <img class="onboarding--img" src="@/assets/images/onboarding/teaching.svg"   />
        </div>

        <div class="flex flex-wrap content-center text-center justify-center md:w-1/2 md:text-left md:justify-start">
          <p class="mb-2 onboarding-title font-bold text-dark w-full">What you accomplish</span></p>

       <div class="flex justify-center w-full mt-3">
          <div>
            <vs-radio vs-name="doIKnowMyDream" class="mx-4" color="dark"  v-model="doIKnowMyDream" vs-value="yes">I know what I am going to accomplish</vs-radio>
          </div>

            <div>
              <vs-radio vs-name="doIKnowMyDream" class="mx-4" color="dark"  v-model="doIKnowMyDream" vs-value="no">Inspire me</vs-radio>
            </div>
         </div>

            <div v-if="doIKnowMyDream == 'no'" class="w-full">

              <div v-for="track in tracks" :key="track.id" class="w-full" >
              {{track.name }}
              </div>

            </div>
        </div>
      </div>
    </tab-content> -->

    <!-- DREAM ========================================================= content -->
    <tab-content title="" class="mb-2 mt-5 " :before-change="validateDreamStep">

      <div class="md:flex">
        <div class="w-4/5 md:w-1/2 mx-auto flex content-center">
          <img src="@/assets/images/onboarding/vision.svg"/>
        </div>

        <div class="flex flex-wrap content-center text-center justify-center md:w-1/2 md:text-left md:justify-start">
          <p class="mb-2 w-full text-5xl md:text-6xl"><span class="font-black text-dark">In one year</span></p>

            <p class="text-dark w-full text-base">
              To focus on the things that matter, you need to know your destination, your dreams. Let the destination drive your actions, not the other way around.
            </p>

            <!-- <p class="font-italic my-2 w-full">"Let the destination drive your actions, not the other way around."</p> -->

           <p class="mt-8 mb-1"><span class="text-xl font-black text-dark">What one thing do you want to accomplish in one year?</span></p>


            <form class="w-full" data-vv-scope="step-dream" v-on:submit.prevent>
                <div class="mt-2">
                  <vs-input color="dark" @keyup.enter.native="next" v-model="dream.title" class="w-full" name="dream_title" v-validate="'required'" label="" autocomplete="off" placeholder="name of my first dream/vision"/>
                  <span class="text-danger">{{ errors.first('dream_title', 'step-dream') }}</span>
                </div>
            </form>

            <!-- <p class="font-italic mt-2">Writing down your dreams is the first step in turning the invisible into the visible. <HowToCreateDream/></p> -->
            <p class="font-italic"><HowToCreateDream/></p>


        </div>
      </div>

    </tab-content>


    <!-- GOAL========================================================= content -->
    <tab-content title="" class="mb-2 mt-5" :before-change="validateGoalStep">
      <div class="md:flex">
        <div class="w-4/5 md:w-1/2 mx-auto flex content-center">
          <img class="onboarding--img" src="@/assets/images/onboarding/location.svg"/>
        </div>

        <div class="flex flex-wrap content-center text-center justify-center md:w-1/2 md:text-left md:justify-start">
          <p class="mb-2 w-full text-5xl md:text-6xl"><span class="font-black text-dark">In one month</span></p>

            <p class="text-dark w-full">
              Move confidently toward your dreams by setting smaller, achievable goals. Do not be afraid to start small. One achieved goal is better than five goals you never reach.
            </p>

<!-- <p class="text-dark mt-4 w-full"><span>Do not be afraid to start small. One goal achieved is better than five goals you never reach.</span></p> -->


            <!-- <p class="text-dark mt-4 w-full"><span>Do not be afraid to start small. One goal achieved is better than five goals you never reach.</span></p> -->

          <p class="mt-8"><span class="font-bold text-xl text-dark">What am I going to achieve in one month towards my dream?</span></p>
            <form class="w-full" data-vv-scope="step-goal" v-on:submit.prevent>
              <div class="mt-2">
                <vs-input color="dark" v-validate="'required'" @keyup.enter.native="next" v-model="goal.title" placeholder="name of my first achiavable goal" class="w-full" name="goal_title" autocomplete="off"/>
                <span class="text-danger">{{ errors.first('goal_title', 'step-goal') }}</span>
              </div>
            </form>

            <p class="font-italic text-sm">Make your goal realistic and specific so you can track your progress and eventually reach your goal.</p>

        </div>
      </div>
    </tab-content>


    <!-- TASK AND ROUTINE ========================================================= -->
    <tab-content title="" class="mb-2 mt-5" :before-change="validateTaskAndRoutineStep">
      <div class="md:flex">
        <div class="w-4/5 md:w-1/2 mx-auto flex content-center">
          <img class="onboarding--img" src="@/assets/images/onboarding/jogging.svg"/>
        </div>

        <div class="flex flex-wrap content-center text-center justify-center md:w-1/2 md:text-left md:justify-start w-full">
          <p class="mb-2 w-full text-5xl md:text-6xl"><span class="font-black text-dark">Today</span></p>
            <p class="text-dark w-full">
              The gap between a dream and reality can be filled by actions.
              Dreams are your inspiration, goals are your plan, but only action - even a small one - will make a difference. One step at a time.
            </p>

            <form class="w-full" data-vv-scope="step-task-routine" v-on:submit.prevent>

            <p class="mt-8 mb-2"><span class="font-bold text-xl text-dark">What small action will I take today to get closer to my goal?</span></p>

 <!--                <p class="mt-4"><span class="font-bold">Define today's task to come closer to {{goal.title}}</span></p> -->

              <div class="mt-2">
                <vs-input v-validate="'required'" placeholder="my first task for today" color="dark" @keyup.enter.native="next" v-model="task.title" class="w-full" name="task_title" autocomplete="off"/>
                <span class="text-danger">{{ errors.first('task_title', 'step-task-routine') }}</span>
              </div>

              <div class="mt-2">
                <vs-input color="dark" v-validate="'required'" placeholder="my first daily routine" @keyup.enter.native="next" v-model="routine.title" class="w-full" name="routine_title" autocomplete="off"/>
                <span class="text-danger">{{ errors.first('routine_title', 'step-task-routine') }}</span>
              </div>
            </form>

            <p class="font-italic text-sm">Your future depends on what you do today and everyday.</p>

        </div>
      </div>
    </tab-content>


  </form-wizard>
</template>

<script>
/* eslint-disable */

import _ from 'lodash'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import IntroStepContent from './Wizard/IntroStepContent'
import HowToCreateDream from './Wizard/HowToCreateDream'
import DreamText from './Wizard/DreamText'
import DreamTextOutro from './Wizard/DreamTextOutro'
import JournalText from './Wizard/JournalText'
import GoalText from './Wizard/GoalText'
import GoalTextOutro from './Wizard/GoalTextOutro'
import Checkbox from './Wizard/Checkbox'
import * as DateHelper from '@/helpers/date'
import FullScreenLoading   from '@/views/Self-Improvee/Generic/FullScreenLoading'
import trackAnalytics from '@/helpers/trackAnalytics'
import CategorySelect from './../Dreams/CategorySelect'
import DemoDreams from '@/models/DemoDreams'

// import { LearnAppGoals }  from './../Goals/GoalsExamples'

// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    what_are_you_solving: {
      required: 'Please tell us what you expect from us so that we can improve for you and others.',
    },
    dream_title: {
      required: 'This is a crucial part of your journey',
    },
    dream_why: {
      required: 'If you don\'t know why, then you shouldn\'t pursue it',
    },
    biggest_acomplishment: {
      required: 'You have certainly achieved something already',
    },
    goal_title: {
      required: 'Dreams don\'t work unless you do',
    },
    task_title: {
      required: 'You are what you do, not what you say you\'ll do',
    },
    routine_title: {
      required: 'Even using improvee.io everyday is a routine',
    },
    next_month_step: {
      required: 'Job title name is required',
      alpha: 'Job title may only contain alphabetic characters'
    },
    proposal_title: {
      required: 'Proposal title name is required',
      alpha: 'Proposal title may only contain alphabetic characters'
    },
    event_name: {
      required: 'Event name is required',
      alpha: 'Event name may only contain alphabetic characters'
    },
  }
}

// register custom messages
Validator.localize('en', dict)

export default {
  components: {
    FormWizard,
    TabContent,
    IntroStepContent,
    DreamText,
    HowToCreateDream,
    JournalText,
    GoalText,
    GoalTextOutro,
    DreamTextOutro,
    FullScreenLoading,
    CategorySelect,
    Checkbox
  },
  data () {
    return {
      iWishTo: [],
      dream: { category: 'other' },
      imageFile: null,
      goal: {},
      task: {},
      routine: {},
      fullScreenloading: false,
      tracks: [],
      doIKnowMyDream: 'yes',
      firstPartNotFinished: true
    }
  },
  computed: {
    userName () {
      return this.$store.getters.userFirstName
    },
  },
  methods: {
    trackStep (step) {
      return () => {
        return new Promise((resolve) => {
          this.track(step)
          resolve(true)
        })
      }
    },
    track (step) {
      trackAnalytics(this, 'app_action', `setupapp-journey-${step}`, null, this.$store.getters.daysFromRegistration)
    },
    skipTour () {
      trackAnalytics(this, 'app_action', `setupapp-journey-skipped`, null, this.$store.getters.daysFromRegistration)

      this.save()
    },
    next () {
      this.$refs.onboardingWizard2.nextTab()
    },
    // validateStep1 () {
    //   return new Promise((resolve, reject) => {
    //     this.$validator.validateAll('step-1').then(result => {
    //       if (result) {
    //         this.updateWhatAreYouTryingToSolve()
    //         trackAnalytics(this, 'app_action', 'setupapp-journey-step-1-finished', null, this.$store.getters.daysFromRegistration)
    //         resolve(true)
    //       } else {
    //         reject('correct all values')
    //       }
    //     })
    //   })
    // },
    storeWhatWeHave () {
      return new Promise((resolve) => {
        this.updateWhatAreYouTryingToSolve()
        this.track('i-wish-to-step-finished')
        resolve(true)
      })
    },

    validateDreamStep () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-dream').then(result => {
          if (result) {
            trackAnalytics(this, 'app_action', 'setupapp-journey-step-dream-finished', null, this.$store.getters.daysFromRegistration)
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    youCanYouWillFinished () {
     return new Promise((resolve) => {
        // trackStep('you-can-tou-will-step-finished')
        this.firstPartNotFinished = false
        resolve(true)
      })
    },
    validateGoalStep () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-goal').then(result => {
          if (result) {
            trackAnalytics(this, 'app_action', 'setupapp-journey-step-goal-finished', null, this.$store.getters.daysFromRegistration)
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateTaskAndRoutineStep () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-task-routine').then(result => {
          if (result) {
            trackAnalytics(this, 'app_action', 'setupapp-journey-step-task-routine-finished', null, this.$store.getters.daysFromRegistration)
            this.$store.dispatch('ADDITIONAL_USER_INFO', { helloAndWelcomeEnded: true })
            this.save()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    async save () {
      this.fullScreenloading = true

      if (this.imageFile) await this.uploadImage()

      if (this.dream.title) {
        _.each(_.map(_.split(this.dream.title, ','), (a) => a.trim()), (dreamTitle) => {

          if (dreamTitle) {
            const dream = { ...this.dream, title: dreamTitle }
            this.$store.dispatch('ADD_DREAM', { dream })
          }

        })

        trackAnalytics(this, 'app_action', 'appsetup', null, this.$store.getters.daysFromRegistration)
      }

      if (this.goal.title) {
        _.each(_.map(_.split(this.goal.title, ','), (a) => a.trim()), (goalTitle) => {
          if (goalTitle) {
            const goal = {
              title: goalTitle,
              deadline: DateHelper.oneMonthFromNow()
            }

            this.$store.dispatch('ADD_GOAL', { goal })
          }

        })
      }

      if (this.task.title) {
        _.each(_.map(_.split(this.task.title, ','), (a) => a.trim()), (taskTitle) => {

          if (taskTitle) {
            const task = { ...this.task, deadline: DateHelper.midnight(), title: taskTitle }

            this.$store.dispatch('ADD_TASK', { task })
          }

        })
      }


      if (this.routine.title) {
        _.each(_.map(_.split(this.routine.title, ','), (a) => a.trim()), (routineTitle) => {
          if (routineTitle) {
            const routine = { ...this.routine, title: routineTitle }

            this.$store.dispatch('ADD_ROUTINE', { routine })
          }

        })
      }




      // if (this.nextMonthGoal.title) {
      //   this.nextMonthGoal.dreamId = dreamId
      //   this.nextMonthGoal.period = nextPeriod()
      //   this.$store.dispatch('ADD_GOAL', { goal: this.nextMonthGoal })
      // }

      // if (this.biggestAccomplishment) {
      //   this.$store.dispatch('ADD_STORY', { title: this.biggestAccomplishment, tag: 'achievement' })
      // }

      // if (this.fail) {
      //   this.$store.dispatch('ADD_STORY', { title: this.fail, tag: 'fail' })
      // }

      // Update user -------------------------------------------------

      // this.updateWhatAreYouTryingToSolve()
      // await this.$store.dispatch('UPDATE_USER_ONBOARDED', false)
      this.$store.commit('SET_SHOW_SETUP', false)
      // this.$store.dispatch('ADD_INITIAL_TIP_DELAYED')
      // this.$store.dispatch('ADD_SECOND_TIP_DELAYED')

      // this.$vs.notify({
      //   title: 'Welcome!',
      //   text: 'We wish you achieve your dreams.',
      //   color: 'success',
      //   iconPack: 'feather',
      //   time: 3000,
      //   icon:'icon-check'})

      this.fullScreenloading = false
    },
    updateWhatAreYouTryingToSolve () {
      const whatAreYouTryingToSolve = this.iWishTo
      const user = Object.assign({}, this.$store.getters.user)

      user.userPreferences = { whatAreYouTryingToSolve }
      this.$store.dispatch('UPDATE_USER', { user })
    },
    imgFileChanged (path, files) {
      const file = files[0]
      this.imageFile = file
    },
    async storeGoal (dreamId, { subgoals, title }) {
      const res = await this.$store.dispatch('ADD_GOAL', { goal: { dreamId, title } })
      const goalId = res.id
      if (subgoals) {
        subgoals.forEach(subgoal => this.$store.dispatch('ADD_SUBGOAL', { subgoal: { goalId, ...subgoal } }))
      }
    },
    async uploadImage () {
      this.dream.img = await this.$store.dispatch('UPLOAD_DREAM_IMAGE', {
        file: this.imageFile,
        dream: this.dream
      })
    }
  },
  mounted () {
    this.tracks = DemoDreams.tracks
    this.track('before')
  }
}
</script>
<style>
.img-upload, .con-upload, .con-img-upload, .con-input-upload {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

.wizard-btn {
  border-radius: 1rem !important;
  font-size: larger !important;
}

.con-input-upload {
  height: 104px !important;
}

.view-upload {
  display: none !important;
}

.onboarding--img {
  max-height: 500px;
}

.onboarding-image {
  max-height: 500px;
}

.onboarding-image-smaller {
  max-height: 400px;
}

.{
  margin-top: 1rem;
  font-size: 1.3rem;
}

.onboarding-input {
  margin-top: 2rem;
}

.onboarding-bold {
  font-weight: bold;
}

.onboarding-it {
  font-style: italic;
}

.onboarding-title {
  font-size: 4rem;
}

@media screen and (min-width: 1200px) {
  .onboarding__text-right {

  }
}

@media screen and (min-width: 1200px) {
  .wizard-tab-content {
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .wizard-card-footer{
    margin-left: 10rem;
    margin-right: 10rem;
  }
}
</style>
